// Área "cards" — preenchida na cobertura de 4 idiomas. Ver src/i18n/index.jsx.
// Fallback: idioma ausente cai para pt e, se faltar, para a própria chave.
const cards = {
  pt: {
    'cards.loading': "Carregando cartões...",
    'cards.title': "Meus Cartões",
    'cards.subtitle': "Gerencie seus cartões de crédito",
    'cards.cardholder': "PORTADOR",
    'cards.valid_until': "VÁLIDO ATÉ",
    'cards.hide_data': "Ocultar dados",
    'cards.show_card_data': "Ver dados do cartão",
    'cards.available_limit': "Limite Disponível",
    'cards.of_total': "de {amount} total",
    'cards.used': "Usado: {amount}",
    'cards.current_invoice': "Fatura Atual",
    'cards.due_date': "Vencimento: {date}",
    'cards.status_open': "Aberta",
    'cards.pay_invoice': "Pagar Fatura",
    'cards.view_full_invoice': "Ver Fatura Completa",
    'cards.quick_actions': "Ações Rápidas",
    'cards.block': "Bloquear",
    'cards.second_copy': "2ª Via",
    'cards.limit': "Limite",
    'cards.configure': "Configurar",
    'cards.recent_transactions': "Últimas Transações",
    'cards.view_all': "Ver todas",
    'cards.no_recent_transactions': "Nenhuma transação recente",
    'cards.cat_online_shopping': "Compras Online",
    'cards.cat_transport': "Transporte",
    'cards.cat_streaming': "Streaming",
    'cards.back_to_dashboard': "Voltar ao Dashboard",
  },
  es: {
    'cards.loading': "Cargando tarjetas...",
    'cards.title': "Mis Tarjetas",
    'cards.subtitle': "Gestione sus tarjetas de crédito",
    'cards.cardholder': "TITULAR",
    'cards.valid_until': "VÁLIDO HASTA",
    'cards.hide_data': "Ocultar datos",
    'cards.show_card_data': "Ver datos de la tarjeta",
    'cards.available_limit': "Límite Disponible",
    'cards.of_total': "de {amount} total",
    'cards.used': "Usado: {amount}",
    'cards.current_invoice': "Factura Actual",
    'cards.due_date': "Vencimiento: {date}",
    'cards.status_open': "Abierta",
    'cards.pay_invoice': "Pagar Factura",
    'cards.view_full_invoice': "Ver Factura Completa",
    'cards.quick_actions': "Acciones Rápidas",
    'cards.block': "Bloquear",
    'cards.second_copy': "Duplicado",
    'cards.limit': "Límite",
    'cards.configure': "Configurar",
    'cards.recent_transactions': "Últimas Transacciones",
    'cards.view_all': "Ver todas",
    'cards.no_recent_transactions': "Ninguna transacción reciente",
    'cards.cat_online_shopping': "Compras Online",
    'cards.cat_transport': "Transporte",
    'cards.cat_streaming': "Streaming",
    'cards.back_to_dashboard': "Volver al Panel",
  },
  en: {
    'cards.loading': "Loading cards...",
    'cards.title': "My Cards",
    'cards.subtitle': "Manage your credit cards",
    'cards.cardholder': "CARDHOLDER",
    'cards.valid_until': "VALID THRU",
    'cards.hide_data': "Hide data",
    'cards.show_card_data': "View card data",
    'cards.available_limit': "Available Limit",
    'cards.of_total': "of {amount} total",
    'cards.used': "Used: {amount}",
    'cards.current_invoice': "Current Statement",
    'cards.due_date': "Due date: {date}",
    'cards.status_open': "Open",
    'cards.pay_invoice': "Pay Statement",
    'cards.view_full_invoice': "View Full Statement",
    'cards.quick_actions': "Quick Actions",
    'cards.block': "Block",
    'cards.second_copy': "Replacement",
    'cards.limit': "Limit",
    'cards.configure': "Settings",
    'cards.recent_transactions': "Recent Transactions",
    'cards.view_all': "View all",
    'cards.no_recent_transactions': "No recent transactions",
    'cards.cat_online_shopping': "Online Shopping",
    'cards.cat_transport': "Transport",
    'cards.cat_streaming': "Streaming",
    'cards.back_to_dashboard': "Back to Dashboard",
  },
  it: {
    'cards.loading': "Caricamento carte...",
    'cards.title': "Le mie Carte",
    'cards.subtitle': "Gestisci le tue carte di credito",
    'cards.cardholder': "TITOLARE",
    'cards.valid_until': "VALIDA FINO A",
    'cards.hide_data': "Nascondi dati",
    'cards.show_card_data': "Vedi dati della carta",
    'cards.available_limit': "Limite Disponibile",
    'cards.of_total': "di {amount} totale",
    'cards.used': "Utilizzato: {amount}",
    'cards.current_invoice': "Estratto Attuale",
    'cards.due_date': "Scadenza: {date}",
    'cards.status_open': "Aperta",
    'cards.pay_invoice': "Paga Estratto",
    'cards.view_full_invoice': "Vedi Estratto Completo",
    'cards.quick_actions': "Azioni Rapide",
    'cards.block': "Blocca",
    'cards.second_copy': "Duplicato",
    'cards.limit': "Limite",
    'cards.configure': "Configura",
    'cards.recent_transactions': "Ultime Transazioni",
    'cards.view_all': "Vedi tutte",
    'cards.no_recent_transactions': "Nessuna transazione recente",
    'cards.cat_online_shopping': "Acquisti Online",
    'cards.cat_transport': "Trasporto",
    'cards.cat_streaming': "Streaming",
    'cards.back_to_dashboard': "Torna alla Dashboard",
  },
};

export default cards;
